/**
 * GENERATED FILE — DO NOT EDIT.
 * Source: tokens/tokens.json + tokens/defaults.json
 * Regenerate: node scripts/generate-tokens.mjs
 */
export const DEFAULT_WIDGET_THEME = {
    "primaryColor": "#0a0a0b",
    "primaryTextColor": "#ffffff",
    "backgroundColor": "#ffffff",
    "surfaceColor": "#f3f4f6",
    "agentBubbleColor": "",
    "textColor": "#0a0a0b",
    "mutedTextColor": "#6b7280",
    "borderColor": "#e5e7eb",
    "errorColor": "#ef4444",
    "successColor": "#16a34a",
    "buttonStyle": "pill",
    "borderRadius": "16px",
    "fontFamily": "inherit"
};
export const WIDGET_PRESET_THEMES = {
    "light": {
        "primaryColor": "#18181b",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#ffffff",
        "surfaceColor": "#f4f4f5",
        "textColor": "#18181b",
        "mutedTextColor": "#71717a",
        "borderColor": "#e4e4e7"
    },
    "warm": {
        "primaryColor": "#57534e",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#fefefe",
        "surfaceColor": "#fafaf9",
        "textColor": "#1c1917",
        "mutedTextColor": "#78716c",
        "borderColor": "#e7e5e4"
    },
    "blue": {
        "primaryColor": "#2563eb",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#fafcff",
        "surfaceColor": "#f0f7ff",
        "textColor": "#1e3a8a",
        "mutedTextColor": "#64748b",
        "borderColor": "#dbeafe"
    },
    "indigo": {
        "primaryColor": "#6366f1",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#fbfbff",
        "surfaceColor": "#f5f5ff",
        "textColor": "#312e81",
        "mutedTextColor": "#6b7280",
        "borderColor": "#e0e7ff"
    },
    "green": {
        "primaryColor": "#16a34a",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#fbfefb",
        "surfaceColor": "#f0fdf4",
        "textColor": "#14532d",
        "mutedTextColor": "#6b7280",
        "borderColor": "#dcfce7"
    },
    "orange": {
        "primaryColor": "#ea580c",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#fffdfb",
        "surfaceColor": "#fff7ed",
        "textColor": "#7c2d12",
        "mutedTextColor": "#78716c",
        "borderColor": "#ffedd5"
    },
    "dark": {
        "primaryColor": "#fafafa",
        "primaryTextColor": "#18181b",
        "backgroundColor": "#18181b",
        "surfaceColor": "#27272a",
        "textColor": "#fafafa",
        "mutedTextColor": "#a1a1aa",
        "borderColor": "#3f3f46"
    },
    "sunset": {
        "primaryColor": "linear-gradient(135deg, #f97316, #ef4444)",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#fffbf7",
        "surfaceColor": "#fff3e8",
        "textColor": "#7c2d12",
        "mutedTextColor": "#9a3412",
        "borderColor": "#fed7aa"
    },
    "ocean": {
        "primaryColor": "linear-gradient(135deg, #667eea, #764ba2)",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#faf9ff",
        "surfaceColor": "#f0edff",
        "textColor": "#312e81",
        "mutedTextColor": "#6366f1",
        "borderColor": "#ddd6fe"
    },
    "emerald": {
        "primaryColor": "linear-gradient(135deg, #10b981, #0ea5e9)",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#f7fdfb",
        "surfaceColor": "#ecfdf5",
        "textColor": "#064e3b",
        "mutedTextColor": "#047857",
        "borderColor": "#a7f3d0"
    },
    "midnight": {
        "primaryColor": "linear-gradient(135deg, #6366f1, #8b5cf6)",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#18181b",
        "surfaceColor": "#27272a",
        "textColor": "#fafafa",
        "mutedTextColor": "#a1a1aa",
        "borderColor": "#3f3f46"
    },
    "policybazaar": {
        "primaryColor": "linear-gradient(88deg, #9403fd, #00adfe)",
        "primaryTextColor": "#ffffff",
        "backgroundColor": "#ffffff",
        "surfaceColor": "#f4f2ff",
        "agentBubbleColor": "linear-gradient(107deg, #f0fff9, #f7eeff)",
        "textColor": "#18181b",
        "mutedTextColor": "#64748b",
        "borderColor": "#e6e2ff"
    }
};
export const TIMING = {
    "chatWidgetGraceMs": 800,
    "chatWidgetAfterTextMs": 120,
    "minTypingIndicatorMs": 500
};
export const WIDGET_DEFAULTS = {
    "mode": "prod",
    "title": "Ringg AI Support",
    "description": "Ringg AI offers 24/7 voice support to handle your business calls efficiently and professionally",
    "defaultTab": "audio",
    "hideTabSelector": false,
    "defaultExpanded": false,
    "bypassStartScreen": false,
    "bypassFeedbackScreen": false,
    "voiceCallShowAnimation": false,
    "voiceCallShowTranscript": true,
    "notificationTuneUrl": "https://assets.ringg.ai/audios/misc/widget_notification.mp3"
};
